import React__default from 'react';
import OpenChannelUI from './OpenChannel/components/OpenChannelUI.js';
import { O as OpenChannelProvider } from './chunks/bundle-c6Xd_0m8.js';
import './OpenChannel/components/OpenChannelInput.js';
import './chunks/bundle-d1cOX5nv.js';
import './chunks/bundle-CxLxJCBu.js';
import './chunks/bundle-DS1EhNtb.js';
import './ui/MessageInput.js';
import './chunks/bundle-D2GzZ_yy.js';
import './chunks/bundle-CpMvhj21.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-CjJk57u5.js';
import './chunks/bundle-GawAxqNK.js';
import 'dompurify';
import './chunks/bundle-B5pWUwTI.js';
import './chunks/bundle-CiR8AZTC.js';
import './chunks/bundle-Bs4dlPq1.js';
import './ui/Icon.js';
import './chunks/bundle-kFa80LJe.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-DiK8ifY3.js';
import './chunks/bundle-C-nZYnmy.js';
import './chunks/bundle-DP3z2QNm.js';
import './chunks/bundle-AmtSwuex.js';
import './OpenChannel/components/FrozenChannelNotification.js';
import './OpenChannel/components/OpenChannelHeader.js';
import './chunks/bundle-DOfhjbKd.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-C_zEpfCP.js';
import './chunks/bundle-Ci-RNuvu.js';
import './ui/PlaceHolder.js';
import './ui/Loader.js';
import './OpenChannel/components/OpenChannelMessageList.js';
import './chunks/bundle-Dq0ggazV.js';
import './OpenChannel/components/OpenChannelMessage.js';
import './chunks/bundle-CewnJAub.js';
import './ui/OpenchannelUserMessage.js';
import './chunks/bundle-BzR1dD25.js';
import 'react-dom';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import './ui/SortByRow.js';
import './chunks/bundle-DKdROCX_.js';
import './ui/UserProfile.js';
import './chunks/bundle-DXFVroy5.js';
import '@sendbird/uikit-tools';
import './chunks/bundle-DRpjMk0B.js';
import 'css-vars-ponyfill';
import './chunks/bundle-DdJ9pMWn.js';
import './sendbirdSelectors.js';
import './chunks/bundle-mqagBpi9.js';
import './chunks/bundle-D4d941oR.js';
import './chunks/bundle-CqNbtpjG.js';
import './chunks/bundle-QsOiwa9F.js';
import './ui/OpenChannelAdminMessage.js';
import './ui/OpenchannelOGMessage.js';
import './ui/LinkLabel.js';
import './chunks/bundle-AV2qqH9G.js';
import './Message/context.js';
import './ui/MentionLabel.js';
import './ui/OpenchannelThumbnailMessage.js';
import './ui/OpenchannelFileMessage.js';
import './ui/TextButton.js';
import './chunks/bundle-B5157rdG.js';
import './ui/DateSeparator.js';
import './ui/FileViewer.js';
import './chunks/bundle-CH6t4mkR.js';
import './chunks/bundle-DcPIDUrE.js';
import './chunks/bundle-gBmMoaTG.js';
import './chunks/bundle-BjAeG049.js';
import './chunks/bundle-AJS7Mngy.js';
import '@sendbird/chat/message';
import './Channel/utils/compareMessagesForGrouping.js';
import './chunks/bundle-DXKWyDSR.js';
import './chunks/bundle-B5N-CojP.js';

var OpenChannel = function (props) {
    return (React__default.createElement(OpenChannelProvider, { channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl, isMessageGroupingEnabled: props === null || props === void 0 ? void 0 : props.isMessageGroupingEnabled, queries: props === null || props === void 0 ? void 0 : props.queries, messageLimit: props === null || props === void 0 ? void 0 : props.messageLimit, onBeforeSendUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendUserMessage, onBeforeSendFileMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendFileMessage, onChatHeaderActionClick: props === null || props === void 0 ? void 0 : props.onChatHeaderActionClick, disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile, renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile, onBackClick: props === null || props === void 0 ? void 0 : props.onBackClick },
        React__default.createElement(OpenChannelUI, { renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage, renderHeader: props === null || props === void 0 ? void 0 : props.renderHeader, renderInput: props === null || props === void 0 ? void 0 : props.renderInput, renderMessageInput: props === null || props === void 0 ? void 0 : props.renderMessageInput, renderPlaceHolderEmptyList: props === null || props === void 0 ? void 0 : props.renderPlaceHolderEmptyList, renderPlaceHolderError: props === null || props === void 0 ? void 0 : props.renderPlaceHolderError, renderPlaceHolderLoading: props === null || props === void 0 ? void 0 : props.renderPlaceHolderLoading })));
};

export { OpenChannel as default };
//# sourceMappingURL=OpenChannel.js.map
